import axios from "axios";
import envConfig from "../config";
import ServiceHelper from "./serviceHelper";
function safeSerializeError(error) {
  if (!error) return null;

  return {
    name: error.name || null,
    message: error.message || null,
    stack: error.stack || null,
    cause: error.cause
      ? {
          name: error.cause?.name || null,
          message: error.cause?.message || null,
          stack: error.cause?.stack || null,
        }
      : null,
  };
}

function getUserAgentData() {
  return {
    userAgent: navigator.userAgent || null,
    language: navigator.language || null,
    languages: navigator.languages || [],
    platform: navigator.platform || null,
    cookieEnabled: navigator.cookieEnabled,
    onLine: navigator.onLine,
    screen: {
      width: window.screen?.width || null,
      height: window.screen?.height || null,
      availWidth: window.screen?.availWidth || null,
      availHeight: window.screen?.availHeight || null,
      colorDepth: window.screen?.colorDepth || null,
      pixelDepth: window.screen?.pixelDepth || null,
    },
    viewport: {
      width: window.innerWidth || null,
      height: window.innerHeight || null,
    },
  };
}

function getLocationData() {
  return {
    href: window.location.href,
    origin: window.location.origin,
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    referrer: document.referrer || null,
  };
}

function getMemoryData() {
  if (!performance || !performance.memory) return null;

  return {
    jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
    totalJSHeapSize: performance.memory.totalJSHeapSize,
    usedJSHeapSize: performance.memory.usedJSHeapSize,
  };
}

function getPerformanceTiming() {
  try {
    const navEntries = performance.getEntriesByType?.("navigation");
    if (navEntries && navEntries.length > 0) {
      const nav = navEntries[0];
      return {
        type: nav.type || null,
        startTime: nav.startTime || null,
        duration: nav.duration || null,
        domComplete: nav.domComplete || null,
        loadEventEnd: nav.loadEventEnd || null,
      };
    }

    return null;
  } catch {
    return null;
  }
}

function getReactErrorPayload({ source, error, componentStack = null, extra = null }) {
  return {
    source: source || "unknown",
    timestampUtc: new Date().toISOString(),
    error: safeSerializeError(error),
    componentStack,
    location: getLocationData(),
    browser: getUserAgentData(),
    memory: getMemoryData(),
    performance: getPerformanceTiming(),
    extra,
  };
}

export async function logFrontendError({ source, error, componentStack = null, extra = null }) {
  const payload = getReactErrorPayload({
    source,
    error,
    componentStack,
    extra,
  });

  const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();
  try {
    axios
      .post(`${envConfig.apiBaseUrl}/api/logs/frontend-error`, payload, {
        ...config,
        headers: {
          ...config?.headers,
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        return true; // ou rien, mais pratique pour debug
      })
      .catch((error) => {
        console.error("Erreur lors de l'envoi du log frontend:", error);
      });
  } catch (err) {
    console.error("Erreur lors de l'envoi du log frontend:", err);
  }
}
